var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmpty = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 512,
  height: 512,
  viewBox: "0 0 135.467 135.467",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 0.794,
  d: "M64.269 23.052L16.052 44.86l3.744 8.28 48.217-21.806zm7.489 0l48.218 21.807-3.745 8.28-48.217-21.807z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M67.958 31.298l.176 43.7",
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 0.529,
  strokeOpacity: 0.502
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.895 70.94v30.32l10.126 4.942V75.59zm62.437-.334v30.777l-10.126 4.92V75.3z",
  fill: "#d21e1e"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M44.335 63.97c-12.837-5.808-23.738-10.727-23.878-10.813-.17-.105 7.944-3.642 23.584-10.715 12.955-5.859 23.63-10.715 23.664-10.676.122.14.215 42.782.094 42.774-.068-.004-10.627-4.76-23.464-10.57z",
  fill: "#d21e1e",
  fillOpacity: 0.301
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M68.273 53.154c-.07-11.759-.105-21.399-.08-21.423.027-.024 10.698 4.773 23.714 10.66l23.666 10.705-.61.311c-.334.172-10.898 4.965-23.475 10.652a10998.306 10998.306 0 00-22.98 10.407c-.06.036-.166-9.554-.235-21.312z",
  fill: "#d21e1e",
  fillOpacity: 0.149
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "normal"
  },
  fill: "#d21e1e",
  stroke: "#d21e1e",
  strokeWidth: 1.489,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "markers stroke fill",
  d: "M8.45 122.556h116.197v.2H8.45z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "normal"
  },
  fill: "#d21e1e",
  stroke: "#d21e1e",
  strokeWidth: 1.302,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "markers stroke fill",
  d: "M17.325 125.481H79.78v.284H17.325z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "normal"
  },
  fill: "#d21e1e",
  stroke: "#d21e1e",
  strokeWidth: 1.158,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "markers stroke fill",
  d: "M84.808 125.418h32.32v.433h-32.32z"
}), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M68.014 116.652l48.348-24.095zm48.206-23.835l.01-29.49z",
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 0.794
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M116.23 53.138L68.015 74.944z",
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 0.529
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 0.794,
  d: "M116.35 53.19L68.135 74.996l3.744 8.28 48.218-21.806z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M19.796 62.967v30.112l48.447 23.568L19.83 93.155z",
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 0.73
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 0.794,
  d: "M19.796 53.14l48.217 21.805-3.744 8.28-48.22-21.808zM68.134 74.997l.02 41.607z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M71.493 47.545c-1.778 19.373 4.419-5.474 5.638-9.398.689-2.219 1.995-6.558.7-7.206-3.388-1.696-5.896 11.778-6.34 16.604zm9.895 5.467c-11.04 16.018 6.534-2.607 9.52-5.43 1.687-1.597 4.952-4.74 4.14-5.94-2.122-3.137-10.91 7.38-13.66 11.37zm-16.66-5.67c1.777 19.374-4.42-5.473-5.638-9.398-.69-2.218-1.996-6.557-.701-7.205 3.388-1.696 5.896 11.777 6.339 16.603zM52.9 52.33c11.04 16.02-6.534-2.606-9.52-5.43-1.687-1.597-4.952-4.74-4.141-5.938 2.123-3.139 10.91 7.378 13.66 11.368z",
  fill: "#d21e1e",
  stroke: "#d21e1e",
  strokeWidth: 0.837
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M28.585 96.847l-8.217-4.004-.09-14.47c-.05-7.96-.076-14.485-.06-14.502.018-.017 3.756 1.655 8.308 3.714l8.276 3.746.039 7.383c.021 4.06.021 10.703 0 14.76l-.04 7.377zM57.39 110.872l-10.267-4.982-.005-14.941-.006-14.941.49.209c.269.115 4.113 1.85 8.542 3.857 4.429 2.006 8.126 3.677 8.216 3.713.092.037.848-1.456 1.73-3.417l1.568-3.482.039 9.81c.021 5.394.021 14.161 0 19.482l-.039 9.673zM68.648 96.595l.012-19.153.71 1.505c.392.828 1.047 2.265 1.457 3.194.41.93.798 1.691.863 1.694.1.003 16.978-7.578 17.304-7.773.062-.037.113 6.591.113 14.73v14.798l-10.16 5.08c-5.588 2.793-10.194 5.079-10.235 5.079-.042 0-.07-8.62-.064-19.154zM99.342 85.894V71.392l7.94-3.584c4.367-1.971 8.059-3.644 8.204-3.716.25-.125.263.594.263 14.072v14.203l-8.11 4.015c-4.46 2.208-8.152 4.014-8.203 4.014-.051 0-.094-6.526-.094-14.502z",
  fill: "none"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty.64400727908a5edaca97e78c9d3c5480.svg";